import React from "react";
import PropTypes from "prop-types";
import { TextField, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  input: {
    textAlign: "start",
  },
  errorText: {
    color: "red",
    fontSize: "14px",
    marginTop: "5px",
  },
}));

const TimeInput = ({ value, onChange, placeholder = "hh:mm:ss", ...rest }) => {
  const classes = useStyles();
  // const [error, setError] = useState(""); - Comentado pois foi feito no Controller do Backend - put

  const handleInputChange = (event) => {
    let inputValue = event.target.value.replace(/[^0-9]/g, ""); // Remove caracteres não numéricos

    // Adiciona ":" automaticamente para o formato hh:mm:ss
    if (inputValue.length > 2) {
      inputValue = `${inputValue.slice(0, 2)}:${inputValue.slice(2)}`;
    }
    if (inputValue.length > 5) {
      inputValue = `${inputValue.slice(0, 5)}:${inputValue.slice(5)}`;
    }

    // Limita o valor a 8 caracteres no total
    if (inputValue.length > 8) {
      inputValue = inputValue.slice(0, 8);
    }

    // Validação ao completar o formato hh:mm:ss - Comentado pois foi feito no Controller do Backend - put
    // if (inputValue.length === 8) {
    //   const [horas, minutos, segundos] = inputValue.split(":").map(Number);
    //   if (minutos > 59 || segundos > 59) {
    //     setError("Valores inválidos!");
    //     return;
    //   }
    // }

    // setError(""); // Limpa erros caso o valor seja válido - Comentado pois foi feito no Controller do Backend - put
    onChange(inputValue);
  };

  return (
    <div>
      <TextField
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        // error={!!error} - Comentado pois foi feito no Controller do Backend - put
        // helperText={error} - Comentado pois foi feito no Controller do Backend - put
        InputLabelProps={{ shrink: true }}
        inputProps={{
          maxLength: 8,
          className: classes.input,
        }}
        {...rest}
      />
    </div>
  );
};

TimeInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default TimeInput;
